module.exports = __webpack_public_path__ + "img/full4-min.8b432395.png";